import "@aws-amplify/ui-react/styles.css";
import { Routes, Route} from "react-router-dom";
import React, { useEffect, useState } from 'react'
import * as StorageModule from 'aws-amplify/storage';

import * as Auth from 'aws-amplify/auth';
import { get } from '@aws-amplify/api'; // Importing only the 'get' function for API calls

import {
  withAuthenticator,
  Button,
  Text,
} from "@aws-amplify/ui-react";
import MainMenu from "./MainMenu";
import Settings from "./Settings";
import List from "./List";
import Find from "./Find";
import IronCondorCustomDelta from "./IronCondorCustomDelta"
import AddStock from "./AddStock";
import Delete from "./Delete";
import RunOne from "./RunOne";
import RunAll from "./RunAll";
import RunMostWatched from "./RunMostWatched";
import RunMostActive from "./RunMostActive";
import RunDayGainers from "./RunDayGainers";
import RunDayLosers from "./RunDayLosers";
import RunWallStreetBets from "./RunWallStreetBets";
import MyPortfolio from "./MyPortfolio";
import RunAggressive from "./RunAggressive";
import RunSmall from "./RunSmall";
import RunUndervalued from "./RunUndervalued";
import RunUnderValuedGrowth from "./RunUnderValuedGrowth";
import RunGrowthTechnology from "./RunGrowthTechnology";
import { useRef } from "react";
import AWS from 'aws-sdk';
import RunCollection from "./RunCollection";
import EditSecurityMenu from "./EditSecurityMenu";
import { ActiveButtonProvider } from './ActiveButtonContext';
import AddSecurityInfo from "./AddSecurityInfo";
import EditSecurityInfo from "./EditSecurityInfo";
import MainMenuBuyWrite from "./MainMenuBuyWrite";
import IronCondorMenu from "./IronCondorMenu";
import GenerateOptionsLegs from "./GenerateOptionsLegs";
import GenerateOptionsLegsTraditional from "./GenerateOptionsLegsTraditional";
import GenerateOptionsLegsTraditionalWeekly from "./GenerateOptionsLegsTraditionalWeekly";
import IronCondorOptionsLegs from "./IronCondorOptionsLegs";
import IronCondorOptionsLegsTraditionalWeekly from "./IronCondorOptionsLegsTraditionalWeekly";
import MyPortfolioIronCondor from "./MyPortfolioIronCondor";
import MyPortfolioButterfly from "./MyPortfolioButterfly";
import EditProfile from "./EditProfile";
import ChangePassword from "./ChangePassword";
import MainMenuLongTerm from "./MainMenuLongTerm";
import RunOneLongTerm from "./RunOneLongTerm";
import RunAllLongTerm from "./RunAllLongTerm";
import RunCollectionLongTerm from "./RunCollectionLongTerm";
import FindEtfsForIc from "./FindEtfsForIc";
import FindIcETFsGrid from "./FindIcETFsGrid";
import AiAnalysis from "./AiAnalysis";
import AiResponse from "./AiResponse";
import Reports from "./Reports";
import IcPerformance from "./IcPerformance";
import IronCondorTraditionalMenu from "./IronCondorTraditionalMenu";
import CompareLongTerm from "./CompareLongTerm";
import EconomicEvents from "./EconomicEvents";
import LandingPage from "./LandingPage";
import MarketDirection from "./MarketDirection";
import ButterflyMenu from "./ButterflyMenu";
import GenerateButterflyOptionsLegs from "./GenerateButterflyOptionsLegs";
import ButterflyOptionsLegs from "./ButterflyOptionsLegs";
import ButterflySettings from "./ButterflySettings";
import StockDetail from "./StockDetail";

export const ScreenSizeContext = React.createContext({ width: 0, height: 0 });
const Storage = StorageModule.uploadData;

function App({ signOut }) {
  let userStatus = useRef("pending");
  const [email, setEmail] = useState();
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const handleResize = (newWidth, newHeight) => {
    console.log("Executing handleResize");
    console.log("handleResize : newWidth = " + newWidth);
    console.log("handleResize : newHeight = " + newHeight);
    setScreenSize({
      width: newWidth,
      height: newHeight,
    });
  };

  const [loading, setLoading] = useState(true);

  const getUserInfo = async () => {
    await Auth.fetchAuthSession();
    const user = await Auth.fetchUserAttributes();
    userStatus.current = user["custom:status"];
    setEmail(user.email);
    setLoading(false);  // Stop loading once user info is retrieved
  };

  useEffect(() => {
    const handleWindowResize = () => {
      handleResize(window.innerWidth, window.innerHeight);
    };

    window.addEventListener('resize', handleWindowResize);

    console.log("useeffect : width = " + screenSize.width);
    console.log("useeffect : typeof(screenSize.width) = " + typeof(screenSize.width));

    if (screenSize.width > 768) {
      var newWidth = screenSize.width * 0.2;
      var newHeight = screenSize.height * 0.2;
      console.log("useeffect : newWidth = " + newWidth + "\tnewHeight = " + newHeight);
      console.log("useeffect : new screenSize.width = " + screenSize.width);

      // Use the new values to update the state
      setScreenSize({
        width: newWidth,
        height: newHeight,
      });
    }

    getUserInfo();


    console.log("useeffect : email=" + email);

    // Remove event listener on component unmount to avoid memory leaks
    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);
  console.log("main : new screenSize.width = " + screenSize.width);
  
  if (loading) {
    return (
      <div>
        <center><b>Loading...</b></center>
      </div>
    );
  }

  //<Route path="/" element={<LandingPage signOut={signOut}/>}/>

  //<Route path="/" element={<MainMenu signOut={signOut}/>}/>

  if (userStatus.current === "approved") {
    return (
      <ScreenSizeContext.Provider value={screenSize}>
        <div>
          <ActiveButtonProvider>
            <Routes>
                <Route path="/" element={<LandingPage signOut={signOut}/>}/>
                <Route path="/mainMenuBuyWrite" element={<MainMenuBuyWrite signOut={signOut}/>} />
                <Route path="/compareLongTerm" element={<CompareLongTerm signOut={signOut}/>} />
                <Route path="/mainMenuLongTerm" element={<MainMenuLongTerm signOut={signOut}/>} />
                <Route path="/ironCondorMenu" element={<IronCondorMenu signOut={signOut}/>} />
                <Route path="/ironCondorTraditionalMenu" element={<IronCondorTraditionalMenu signOut={signOut}/>} />
                <Route path="/butterflyMenu" element={<ButterflyMenu signOut={signOut}/>} />
                <Route path="/generateButterflyOptionsLegs" element={<GenerateButterflyOptionsLegs icType=""/>} />
                <Route path="/generateButterflyOptionsLegsSpy" element={<GenerateButterflyOptionsLegs icType="SPY"/>} />
                <Route path="/generateButterflyOptionsLegsQqq" element={<GenerateButterflyOptionsLegs icType="QQQ"/>} />
                <Route path="/generateButterflyOptionsLegsIwm" element={<GenerateButterflyOptionsLegs icType="IWM"/>} />
                <Route path="/generateButterflyOptionsLegsSpx" element={<GenerateButterflyOptionsLegs icType="SPX"/>} />
                <Route path="/generateButterflyOptionsLegsNdx" element={<GenerateButterflyOptionsLegs icType="NDX"/>} />
                <Route path="/generateButterflyOptionsLegsRut" element={<GenerateButterflyOptionsLegs icType="RUT"/>} />
                <Route path="/butterflyOptionsLegs" element={<ButterflyOptionsLegs />} />
                <Route path="/economicEvents" element={<EconomicEvents icType=""/>} />
                <Route path="/marketDirection" element={<MarketDirection signOut={signOut}/>} />
                <Route path="/generateOptionsLegs" element={<GenerateOptionsLegs icType=""/>} />
                <Route path="/generateOptionsLegsTraditional" element={<GenerateOptionsLegsTraditional icType=""/>} />
                <Route path="/generateOptionsLegsTraditionalWeekly" element={<GenerateOptionsLegsTraditionalWeekly icType=""/>} />
                <Route path="/generateOptionsLegsTraditionalWeeklySpy" element={<GenerateOptionsLegsTraditionalWeekly icType="SPY"/>} />
                <Route path="/generateOptionsLegsTraditionalWeeklyQqq" element={<GenerateOptionsLegsTraditionalWeekly icType="QQQ"/>} />
                <Route path="/generateOptionsLegsTraditionalWeeklyIwm" element={<GenerateOptionsLegsTraditionalWeekly icType="IWM"/>} />
                <Route path="/generateOptionsLegsSpy" element={<GenerateOptionsLegs icType="SPY"/>} />
                <Route path="/generateOptionsLegsQqq" element={<GenerateOptionsLegs icType="QQQ"/>} />
                <Route path="/generateOptionsLegsIwm" element={<GenerateOptionsLegs icType="IWM"/>} />
                <Route path="/ironCondorOptionsLegs" element={<IronCondorOptionsLegs/>} />
                <Route path="/ironCondorOptionsLegsTraditionalWeekly" element={<IronCondorOptionsLegsTraditionalWeekly/>} />
                <Route path="/myPortfolioIronCondor" element={<MyPortfolioIronCondor signOut={signOut}/>} />
                <Route path="/myPortfolioButterfly" element={<MyPortfolioButterfly signOut={signOut}/>} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/butterflySettings" element={<ButterflySettings signOut={signOut}/>} />
                <Route path="/list" element={<List />} />
                <Route path="/find" element={<Find />} />
                <Route path="ironCondorCustomDelta" element={<IronCondorCustomDelta icType=""/>} />
                <Route path="/add" element={<AddStock />} />
                <Route path="/delete" element={<Delete />} />
                <Route path="/runOne" element={<RunOne />} />
                <Route path="/runOneLongTerm" element={<RunOneLongTerm />} />
                <Route path="/stockDetail" element={<StockDetail signOut={signOut}/>} />
                <Route path="/runAll" element={<RunAll />} />
                <Route path="/runAllLongTerm" element={<RunAllLongTerm />} />
                <Route path="/runMostWatched" element={<RunCollection externalCollection="mostwatched" />} />


                <Route path="/run52wk_toppicks" element={<RunCollection externalCollection="52wk_toppicks" />} />
                <Route path="/run52wk_toppicksLongTerm" element={<RunCollectionLongTerm externalCollection="52wk_toppicks" />} />
                <Route path="/runhigh_volume" element={<RunCollection externalCollection="high_volume" />} />
                <Route path="/runhigh_volumeLongTerm" element={<RunCollectionLongTerm externalCollection="high_volume" />} />
                <Route path="/runhot_stocks" element={<RunCollection externalCollection="hot_stocks" />} />
                <Route path="/runhot_stocksLongTerm" element={<RunCollectionLongTerm externalCollection="hot_stocks" />} />
                <Route path="/runtop_under_10" element={<RunCollection externalCollection="top_under_10" />} />
                <Route path="/runtop_under_10LongTerm" element={<RunCollectionLongTerm externalCollection="top_under_10" />} />
                <Route path="/rundividend" element={<RunCollection externalCollection="dividend" />} />
                <Route path="/rundividendLongTerm" element={<RunCollectionLongTerm externalCollection="dividend" />} />
                <Route path="/runtop_fundamentals" element={<RunCollection externalCollection="top_fundamentals" />} />
                <Route path="/runtop_fundamentalsLongTerm" element={<RunCollectionLongTerm externalCollection="top_fundamentals" />} />
                <Route path="/runtop_tech" element={<RunCollection externalCollection="top_tech" />} />
                <Route path="/runtop_techLongTerm" element={<RunCollectionLongTerm externalCollection="top_tech" />} />
                <Route path="/runj_pattern" element={<RunCollection externalCollection="j_pattern" />} />
                <Route path="/runj_patternLongTerm" element={<RunCollectionLongTerm externalCollection="j_pattern" />} />
                <Route path="/rungolden_cross" element={<RunCollection externalCollection="golden_cross" />} />
                <Route path="/rungolden_crossLongTerm" element={<RunCollectionLongTerm externalCollection="golden_cross" />} />
                <Route path="/rundeath_cross" element={<RunCollection externalCollection="death_cross" />} />
                <Route path="/rundeath_crossLongTerm" element={<RunCollectionLongTerm externalCollection="death_cross" />} />
                <Route path="/runconsolidation" element={<RunCollection externalCollection="consolidation" />} />
                <Route path="/runconsolidationLongTerm" element={<RunCollectionLongTerm externalCollection="consolidation" />} />
                <Route path="/runrsi_overbought" element={<RunCollection externalCollection="rsi_overbought" />} />
                <Route path="/runrsi_overboughtLongTerm" element={<RunCollectionLongTerm externalCollection="rsi_overbought" />} />
                <Route path="/runrsi_oversold" element={<RunCollection externalCollection="rsi_oversold" />} />
                <Route path="/runrsi_oversoldLongTerm" element={<RunCollectionLongTerm externalCollection="rsi_oversold" />} />
                <Route path="/runpenny_gap" element={<RunCollection externalCollection="penny_gap" />} />
                <Route path="/runpenny_gapLongTerm" element={<RunCollectionLongTerm externalCollection="penny_gap" />} />
                <Route path="/rundefensive_stock" element={<RunCollection externalCollection="defensive_stock" />} />
                <Route path="/rundefensive_stockLongTerm" element={<RunCollectionLongTerm externalCollection="defensive_stock" />} />
                <Route path="/runincome_growth" element={<RunCollection externalCollection="income_growth" />} />
                <Route path="/runincome_growthLongTerm" element={<RunCollectionLongTerm externalCollection="income_growth" />} />
                <Route path="/runbuy_longterm" element={<RunCollection externalCollection="buy_longterm" />} />
                <Route path="/runbuy_longtermLongTerm" element={<RunCollectionLongTerm externalCollection="buy_longterm" />} />
                <Route path="/runmoversDown" element={<RunCollection externalCollection="moversDown" />} />
                <Route path="/runmoversDownLongTerm" element={<RunCollectionLongTerm externalCollection="moversDown" />} />
                <Route path="/runmoversUp" element={<RunCollection externalCollection="moversUp" />} />
                <Route path="/runmoversUpLongTerm" element={<RunCollectionLongTerm externalCollection="moversUp" />} />


                <Route path="/runMostWatchedLongTerm" element={<RunCollectionLongTerm externalCollection="mostwatched" />} />
                <Route path="/runMostActive" element={<RunCollection externalCollection="mostactive" />} />
                <Route path="/runMostActiveLongTerm" element={<RunCollectionLongTerm externalCollection="mostactive" />} />
                <Route path="/runDayGainers" element={<RunCollection externalCollection="daygainers" />} />
                <Route path="/runDayGainersLongTerm" element={<RunCollectionLongTerm externalCollection="daygainers" />} />
                <Route path="/runDayLosers" element={<RunCollection externalCollection="daylosers" />} />
                <Route path="/runDayLosersLongTerm" element={<RunCollectionLongTerm externalCollection="daylosers" />} />
                <Route path="/runWallStreetBets" element={<RunCollection externalCollection="wallstreetbets" />} />
                <Route path="/runWallStreetBetsLongTerm" element={<RunCollectionLongTerm externalCollection="wallstreetbets" />} />
                <Route path="/runAggressive" element={<RunCollection externalCollection="aggressive_small_caps" />} />
                <Route path="/runAggressiveLongTerm" element={<RunCollectionLongTerm externalCollection="aggressive_small_caps" />} />
                <Route path="/runSmall" element={<RunCollection externalCollection="small_cap_gainers" />} />
                <Route path="/runSmallLongTerm" element={<RunCollectionLongTerm externalCollection="small_cap_gainers" />} />
                <Route path="/runUndervalued" element={<RunCollection externalCollection="undervalued_large_caps" />} />
                <Route path="/runUndervaluedLongTerm" element={<RunCollectionLongTerm externalCollection="undervalued_large_caps" />} />
                <Route path="/runUnderValuedGrowth" element={<RunCollection externalCollection="undervalued_growth_stocks" />} />
                <Route path="/runUnderValuedGrowthLongTerm" element={<RunCollectionLongTerm externalCollection="undervalued_growth_stocks" />} />
                <Route path="/runGrowthTechnology" element={<RunCollection externalCollection="growth_technology_stocks" />} />
                <Route path="/runGrowthTechnologyLongTerm" element={<RunCollectionLongTerm externalCollection="growth_technology_stocks" />} />
                <Route path="/myPortfolio" element={<MyPortfolio />} />
                <Route path="/myPortfolioIronCondor" element={<MyPortfolioIronCondor />} />
                <Route path="/myPortfolioButterfly" element={<MyPortfolioButterfly />} />
                <Route path="/editSecurityMenu" element={<EditSecurityMenu />} />
                <Route path="/addSecurityInfo" element={<AddSecurityInfo />} />
                <Route path="/editSecurityInfo" element={<EditSecurityInfo />} />
                <Route path="/editProfile" element={<EditProfile />} />
                <Route path="/changePassword" element={<ChangePassword />} />
                <Route path="/findEtfsForIc" element={<FindEtfsForIc />} />
                <Route path="/findIcETFsGrid" element={<FindIcETFsGrid />} />
                <Route path="/aiAnalysis" element={<AiAnalysis />} />
                <Route path="/ai-response" element={<AiResponse />} />
                <Route path="/reports" element={<Reports />} />
                <Route path="/icPerformance" element={<IcPerformance />} />

            </Routes>
          </ActiveButtonProvider>
        </div>
      </ScreenSizeContext.Provider>
    );
  } else {
    return (
      <div>
        <center><b>You are not authorized to access TSPICKER yet.</b>
          <br></br>
          <Button style={{ width: '33.3%', marginTop: "1%", marginBottom:"1%" }} onClick={signOut}>
            <img src="exit.png" alt="Briefcase Icon" title="Sign Out" style={{ marginRight: '5px', width: '33%' }} />
          </Button>
        </center>
      </div>
      
    )
  }
}

export default withAuthenticator(App);